import { Table } from 'antd'
import Title from 'antd/es/typography/Title'
import { FC, useMemo } from 'react'
import { useGetRewindQueueEntriesQuery } from '../../../../../../../store/api/rewind-queue-entries-api'
import { Zones } from '../../../../../../../types/api/rewind-queue-entry'
import { DocumentId } from '../../../../../../../types/strapi/strapi'
import { getRewindQueueQuery } from '../../../../constants/query-params'
import { getRewindRowClassName } from '../../../../helpers/get-rewind-row-class-name'
import RewindQueueTableWrapper from '../../../rewind-queue-table-wrapper'
import CustomRow from '../../../../../flexo/components/machines-queues/components/custom-row'
import { columns } from './columns'

interface MachineWaitingQueueProps {
    machineDocId: DocumentId
}

const MachineWaitingQueue: FC<MachineWaitingQueueProps> = ({ machineDocId }) => {
    const queryParams = useMemo(
        () => getRewindQueueQuery(machineDocId, Zones.Waiting),
        [machineDocId]
    )
    const { data } = useGetRewindQueueEntriesQuery(queryParams)
    const dataSource = data?.data || []

    return (
        <>
            <Title style={{ marginTop: 0 }} level={4}>
                Ожидание
            </Title>
            <RewindQueueTableWrapper
                style={{ flex: 'auto', height: '100%', width: '100%' }}
                filtersSummaryHeight={0}
                tableHasNotPagination
            >
                <Table
                    dataSource={dataSource}
                    columns={columns}
                    pagination={false}
                    rowKey='id'
                    size='small'
                    components={{ body: { row: CustomRow } }}
                    rowClassName={record => getRewindRowClassName(record.rewind_job)}
                />
            </RewindQueueTableWrapper>
        </>
    )
}

export default MachineWaitingQueue
